import { CircularProgress, Stack } from '@mui/material';

export const LOADING_PAGE_INDICATOR_TEST_ID = 'loading-page-indicator';

const LoadingPage = () => (
  <Stack
    direction="column"
    sx={{ justifyContent: 'center', width: '100%', height: '100vh' }}
  >
    <Stack direction="row" sx={{ justifyContent: 'center' }}>
      <CircularProgress
        size="5rem"
        data-test-id={LOADING_PAGE_INDICATOR_TEST_ID}
      />
    </Stack>
  </Stack>
);

export default LoadingPage;
